// extracted by mini-css-extract-plugin
export default {"wrap":"tH-z","fullWidth":"uH-z","hideOnDesktop":"vH-z","content":"wH-z","hasOpenedNav":"xH-z","crumbsList":"yH-z","dropdownsWrap":"zH-z"};